import React, { createContext, useEffect, useMemo, useState } from 'react'
import { darkTheme, lightTheme } from '../themes.js'

export const ThemeContext = createContext(null)

export function ThemeProvider({ children }) {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const storedValue = localStorage.getItem('isDarkMode')
    return storedValue !== null ? JSON.parse(storedValue) : true
  })

  useEffect(() => {
    localStorage.setItem('isDarkMode', JSON.stringify(isDarkMode))
  }, [isDarkMode])

  useEffect(() => {
    document.body.classList.toggle('theme-dark', isDarkMode)
    document.body.classList.toggle('theme-light', !isDarkMode)
    document.documentElement.setAttribute(
      'data-bs-theme',
      isDarkMode ? 'dark' : 'light'
    )
  }, [isDarkMode])

  const theme = useMemo(() => {
    return isDarkMode ? darkTheme : lightTheme
  }, [isDarkMode])

  const value = {
    theme,
    isDarkMode,
    setIsDarkMode
  }

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
}
